export const baseConfig = {
  showMathMenu: true,
  tex2jax: {
    inlineMath: [['\\(', '\\)']],
  },
  MathML: {
    loader: { load: ['[mml]/mml3'] },
    extensions: ['mml3.js'],
  },
  skipStartupTypeset: true,
  extensions: ['[a11y]/accessibility-menu.js'],
  menuSettings: {
    explorer: true,
  },
  explorer: {
    walker: 'syntactic',
    highlight: true,
    background: 'blue',
    foreground: 'black',
    speech: true,
    generation: true,
    subtitle: true,
    ruleset: 'mathspeak-default',
  },
}

// Configure MathJax before loading
export const mathJax3Config = {
  loader: {
    load: [
      'a11y/sre',
      'a11y/assistive-mml',
      'a11y/explorer',
      'input/tex',
      'input/mml',
      'output/chtml',
    ],
  },
  tex: {
    inlineMath: [['\\(', '\\)']],
    displayMath: [
      ['$$', '$$'],
      ['\\[', '\\]'],
    ],
  },
  chtml: {
    scale: 1,
  },
  options: {
    enableExplorer: true,
    menuOptions: {
      settings: {
        explorer: true,
      },
    },
    ignoreHtmlClass: 'no-mathjax', // Optional: skip certain elements
    processHtmlClass: 'mathjax-process', // Optional: process only specific elements
  },
  startup: {
    ready: function () {
      if ('startup' in window.MathJax) {
        window.MathJax.startup.defaultReady()
      }
    },
    defaultReady: function () {
      // Default ready implementation
    },
    promise: Promise.resolve(),
  },
}
